import { createBrowserClient } from "@supabase/ssr";

const retiredSupabaseProjectRefs = new Set(["iszjlvfxaedbnfrppytf"]);

function getRequiredEnv(name: string, value: string | undefined): string {
  const trimmedValue = value?.trim();
  if (!trimmedValue) {
    throw new Error(`Missing required environment variable: ${name}`);
  }

  return trimmedValue;
}

function normalizeSupabaseUrl(value: string): string {
  const valueWithProtocol = /^https?:\/\//i.test(value)
    ? value
    : `https://${value}`;

  let url: URL;
  try {
    url = new URL(valueWithProtocol);
  } catch {
    throw new Error(
      "Invalid REACT_APP_SUPABASE_URL. Use the full project URL, for example https://your-project-ref.supabase.co."
    );
  }

  const projectRef = url.hostname.split(".")[0];
  if (retiredSupabaseProjectRefs.has(projectRef)) {
    throw new Error(
      `Invalid REACT_APP_SUPABASE_URL: ${projectRef} is a retired Supabase project. Update Netlify to the active project URL.`
    );
  }

  const isLocalSupabase =
    url.hostname === "localhost" || url.hostname === "127.0.0.1";
  if (!isLocalSupabase && url.protocol !== "https:") {
    throw new Error("REACT_APP_SUPABASE_URL must use https in production.");
  }

  return url.toString().replace(/\/$/, "");
}

export const supabaseUrl = normalizeSupabaseUrl(
  getRequiredEnv("REACT_APP_SUPABASE_URL", process.env.REACT_APP_SUPABASE_URL)
);
export const supabasePublishableKey =
  process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY ||
  getRequiredEnv(
    "REACT_APP_SUPABASE_ANON_KEY",
    process.env.REACT_APP_SUPABASE_ANON_KEY
  );

export const supabase = createBrowserClient(
  supabaseUrl,
  supabasePublishableKey,
  {
    auth: {
      detectSessionInUrl: false,
      flowType: "pkce",
    },
  }
);
